import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import {
  fetchApiCallbackAdd,
  IApiCallbackAddRequest,
  IApiCallbackAddResponse,
} from '../../../shared/repositories/monolith-python/unversioned/api-callback-add';

export async function requestCallback(parameters: IApiCallbackAddRequest): Promise<IApiCallbackAddResponse> {
  try {
    const httpApi = getHttpApi();

    const { response } = await fetchApiCallbackAdd({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          withCredentials: false,
        },
      },
    });

    return response;
  } catch (error) {
    const logger = getLogger();

    logger.error(error, {
      domain: 'requestCallback',
    });

    throw error;
  }
}
